// extracted by mini-css-extract-plugin
export default {"floatLabel":"Float_floatLabel__Ktnmp","label":"Float_label__Lw0By","asPlaceholder":"Float_asPlaceholder__Gx-2+","asLabel":"Float_asLabel__q-iA0","input":"Float_input__vOXNB"};